<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="trade_from"
                          label="平台">
              <el-select clearable
                         v-model="form.trade_from"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in tradefrom"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="sku"
                          label="SKU">
              <el-input v-model="form.sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="product_title"
                          label="商品名">
              <el-input v-model="form.product_title"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label-width
                          prop="warning"
                          label="库存预警">
              <el-input v-model="form.warning"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="demand"
                          label="补货需求">
              <el-select clearable
                         v-model="form.demand"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in demandLists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
              <!-- <el-input v-model="form.demand"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col :span="6">
            <el-form-item label-width
                          prop="sales_month"
                          label="近30天销量">
              <!-- <el-input v-model="form.sales_month"></el-input> -->
              <number-range v-model="form.sales_month" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="sales_week"
                          label="近1周销售">
              <!-- <el-input v-model="form.sales_week"></el-input> -->
              <number-range v-model="form.sales_week" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="inventory"
                          label="目前库存">
              <!-- <el-input v-model="form.inventory"></el-input> -->
              <number-range v-model="form.inventory" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="handleSet"
                   type="primary">设置</el-button>
        <el-button @click="handleCalc"
                   type="primary">计算补货</el-button>
        <el-button @click="handleSku"
                   type="primary">设置-SKU</el-button>
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="sku"
                       align="center"
                       header-align="center"
                       label="SKU"></el-table-column>
      <el-table-column prop="product_title"
                       align="center"
                       header-align="center"
                       label="商品名"></el-table-column>
      <el-table-column prop="sales_month"
                       align="center"
                       header-align="center"
                       label="近30天销量"></el-table-column>
      <el-table-column prop="sales_week"
                       align="center"
                       header-align="center"
                       label="近1周销售"></el-table-column>
      <el-table-column prop="inventory"
                       align="center"
                       header-align="center"
                       label="目前库存"></el-table-column>
      <el-table-column prop="warning"
                       align="center"
                       header-align="center"
                       label="库存预警"></el-table-column>
      <el-table-column prop="demand"
                       align="center"
                       header-align="center"
                       label="补货需求"></el-table-column>
					   
	  <el-table-column prop="platform_from" align="center" header-align="center" label="平台"></el-table-column>	   
      <el-table-column prop="profession" align="center" header-align="center" label="行业"></el-table-column>
      <el-table-column prop="business" align="center" header-align="center" label="商家"></el-table-column>
      <el-table-column prop="store" align="center" header-align="center" label="店铺名"></el-table-column>
      <el-table-column prop="updated_at"
                       align="center"
                       header-align="center"
                       label="更新时间">
        <template slot-scope="scope">
          {{
          scope.row.updated_at | parseTime
          }}
        </template>
      </el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <set-dialog ref="refSetDialog"
                :queryInfo="form"></set-dialog>
    <sku-dialog ref="refSkuDialog"
                :queryInfo="form"></sku-dialog>
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import SetDialog from './dialog'
import SkuDialog from './skudialog'
import { parseTime } from '@/utils/index'
export default {
  mixins: [ActionLine, SearchMixin],
  components: {
    SetDialog,
    SkuDialog
  },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
      demandLists: [
        {
          name: '加急补货(加急处理)',
          code: '加急补货(加急处理)',
        },
        {
          name: '马上补货(立即下单)',
          code: '马上补货(立即下单)',
        },
        {
          name: '补货(下个补货日补货)',
          code: '补货(下个补货日补货)',
        },
        {
          name: '无需补货(下个补货日无需补货)',
          code: '无需补货(下个补货日无需补货)',
        },
      ],
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // 覆盖 searchMixin 里的定义
    //计算补货
    async handleCalc() {
      if (!this._collectQuery()) {
        return
      }
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      // console.log(this.form)
      // console.log(this.queryPrdlists)
      let { data, err } = await this.axiosApi(
        this.Desc.callReplenish_api,
        this.queryPrdlists
      )
      // this.loading = false
      if (data && data.status === 200) {
        // console.log(data)
        this.$message.success(data.data.data.message)
      }

      dealReturn(data, err)
    },
    handleSku() {
      if (this.form.profession && this.form.business && this.form.store) {
        // this.getReplenishSetByStore()
        this.$refs.refSkuDialog.show()
      } else {
        this.$message.error('行业、商家、店铺必选')
      }

    },
    getTableData() {},
    handleSearch() {
      if (!this._collectQuery()) {
        return
      }
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      this.getData()
      console.log('this.queryPrdlists', this.queryPrdlists)
    },
    clearSearch() {
      this.form = {
        business: '',
        profession: '',
        store: '',
        trade_from: '',
      }
      console.log('this.queryPrdlists', this.queryPrdlists)
      this.queryPrdlists.query = {}
      this.getData()
    },

    handleExport() {
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      this.$refs.refExportDialog.show()
    },
    async getData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        this.Desc.list_api,
        this.queryPrdlists
      )
      this.loading = false
      if (data && data.data.meta.status === 200) {
        console.log('table')
        console.log(data)
        this.tableData = data.data.data.data
        this.total = parseInt(data.data.data.total)
      }

      dealReturn(data, err)
    },
    async handleSet() {
      // let { data, err } = await this.axiosApi(set_api);
      if (this.form.profession && this.form.business && this.form.store) {
        // this.getReplenishSetByStore()
        this.$refs.refSetDialog.show()
      } else {
        this.$message.error('行业、商家、店铺必选')
      }
    },
    // async getReplenishSetByStore() {
    //   let { data, err } = await this.axiosApi(
    //     this.Desc.replenishr_set_by_store,
    //     {
    //       profession: this.form.profession,
    //       business: this.form.business,
    //       store: this.form.store,
    //     }
    //   )
    //   // console.log(data)
    //   if (data && data.status === 200) {
    //     console.log(data)
    //   }

    //   dealReturn(data, err)
    // },
  },
  watch: {
    pageNumOrPageSizeChange(newVal, oldVal) {
      if (this.searchAreaStatus) {
        this.searchAreaStatus = false // xx
      }
      this.handleSearch()
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/statistics/supply/index.vue